/* eslint-disable camelcase */
import MockAdapter from 'axios-mock-adapter'

import * as AllMocks from './mocks'
import { MockDB, MockType, Tag } from './model/mockDB.model'

import { Brand } from '../modules/brand/model'

const commonApiGateway = 'https://masecare-customer-mm.mocklab.io'

export enum MockDBId {
  // Masmovil:

  Customer_03 = 'Customer_03',
  Customer_03_Subscription_01 = 'Customer_03_Subscription_01',
  Customer_03_Subscription_02 = 'Customer_03_Subscription_02',
  Customer_03_Subscription_03 = 'Customer_03_Subscription_03',
  Customer_03_Subscription_04 = 'Customer_03_Subscription_04',
  Customer_03_Subscription_01_BonusesAvailable_01 = 'Customer_03_Subscription_01_BonusesAvailable_01',
  Customer_03_Subscription_02_BonusesAvailable_01 = 'Customer_03_Subscription_02_BonusesAvailable_01',
  Customer_03_Subscription_01_Balance_01 = 'Customer_03_Subscription_01_Balance_01',
  Customer_03_Subscription_01_Recharges_01 = 'Customer_03_Subscription_01_Recharges_01',
  Customer_03_Energy_01 = 'Customer_03_Energy_01',

  Customer_04 = 'Customer_04',
  Customer_04_Subscription_01 = 'Customer_04_Subscription_01',
  Customer_04_Subscription_01_SubscriptionDetail_01 = 'Customer_04_Subscription_01_SubscriptionDetail_01',
  Customer_04_Subscription_01_Bonuses_01 = 'Customer_04_Subscription_01_Bonuses_01',
  Customer_04_Subscription_01_Promotions_01 = 'Customer_04_Subscription_01_Promotions_01',
  Customer_04_Energy_01 = 'Customer_04_Energy_01',
  Customer_04_Subscription_01_Barring_01 = 'Customer_04_Subscription_01_Barring_01',
  Customer_04_Subscription_01_Service_01 = 'Customer_04_Subscription_01_Service_01',

  Customer_06 = 'Customer_06',
  Customer_06_Subscription_01 = 'Customer_06_Subscription_01',

  // Llamaya
  Customer_05 = 'Customer_05',
  Customer_05_Subscription_01 = 'Customer_05_Subscription_01',
  Customer_05_Subscription_01_SubscriptionDetail_01 = 'Customer_05_Subscription_01_SubscriptionDetail_01',
  Customer_05_Subscription_01_Bonuses_01 = 'Customer_05_Subscription_01_Bonuses_01',
  Customer_05_Subscription_01_BonusesAvailable_01 = 'Customer_05_Subscription_01_BonusesAvailable_01',
  Customer_05_Subscription_01_Balance_01 = 'Customer_05_Subscription_01_Balance_01',
  Customer_05_Subscription_01_Promotions_01 = 'Customer_05_Subscription_01_Promotions_01',
  Customer_05_Subscription_01_Recharges_01 = 'Customer_05_Subscription_01_Recharges_01',
  Customer_05_Subscription_01_Consumptions_01 = 'Customer_05_Subscription_01_Consumptions_01',
  Customer_05_Subscription_01_Barring_01 = 'Customer_05_Subscription_01_Barring_01',
  Customer_05_Subscription_01_Service_01 = 'Customer_05_Subscription_01_Service_01',

  // Agents
  Agent_All = 'Agent_All',
  Agent_01 = 'Agent_01',
  Agent_02 = 'Agent_02',
  Agent_03 = 'Agent_03',
  Agent_04 = 'Agent_04',
}

export const CareMockDB: MockDB = {
  // #################
  // ## Customer_03 ##
  // #################

  // https://masecare-customer-mm.mocklab.io/customers/v7/orgs/${brand}/subscriptions/18876026/bonuses/available?tariffId=249&provinceId=8

  [MockDBId.Customer_03]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03,
    id: '24671825R',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [
      Tag.TWO_ACCOUNTS,
      Tag.HAS_TARIFF_MOBILE,
      Tag.HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS,
      Tag.HAS_COMPATIBLE_BONUSES,
      Tag.HAS_BALANCE,
      Tag.HAS_ENERGY_CONTRACTS,
    ],
    ele: AllMocks.Customer_03,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onPost(`${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/customers/search`, {
          asymmetricMatch(body: any) {
            return body.document === '24671825R' && body.documentType === 'NIF'
          },
        })
        .reply(() => [200, AllMocks.Customer_03])
    },
  },

  [MockDBId.Customer_03_Subscription_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_01,
    id: '18876026',
    identificationNr: '722659262',
    parentNameId: MockDBId.Customer_03,
    parentId: '24671825R',
    accountNumber: 'MMC20112511297409',
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [
      Tag.IS_TARIFF_MOBILE,
      Tag.IS_PREPAID,
      Tag.IS_ACTIVATED,
      Tag.HAS_COMPATIBLE_BONUSES,
      Tag.IN_ACCOUNT_WITH_MANY_PACKAGES,
    ],
  },

  [MockDBId.Customer_03_Subscription_01_BonusesAvailable_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_01_BonusesAvailable_01,
    id: '',
    parentNameId: MockDBId.Customer_03_Subscription_01,
    parentId: '18876026',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD, Tag.HAS_TWO_ELE],
    ele: AllMocks.Customer_03_Subscription_01_BonusesAvailable_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18876026/bonuses/available`,
          {
            params: { tariffId: '249', provinceId: '8' },
          },
        )
        .reply(() => [200, AllMocks.Customer_03_Subscription_01_BonusesAvailable_01])
    },
  },

  [MockDBId.Customer_03_Subscription_01_Balance_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_01_Balance_01,
    id: '',
    parentNameId: MockDBId.Customer_03_Subscription_01,
    parentId: '18876026',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_03_Subscription_01_Balance_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18876026/balance`,
        )
        .reply(() => [200, AllMocks.Customer_03_Subscription_01_Balance_01])
    },
  },

  [MockDBId.Customer_03_Subscription_01_Recharges_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_01_Recharges_01,
    id: '',
    parentNameId: MockDBId.Customer_03_Subscription_01,
    parentId: '18876026',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_03_Subscription_01_Recharges_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18876026/recharges`,
        )
        .reply(() => [200, AllMocks.Customer_03_Subscription_01_Recharges_01])
    },
  },

  [MockDBId.Customer_03_Energy_01]: {
    mockType: 'EnergyContractInfoMock',
    nameId: MockDBId.Customer_03_Energy_01,
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onPost(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/customers/contracts/energy/search`,
          {
            asymmetricMatch(body: any) {
              return body.document === '24671825R'
            },
          },
        )
        .reply(() => [200, AllMocks.Customer_03_Energy_01])
    },
  },

  [MockDBId.Customer_03_Subscription_02]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_02,
    id: '11111111',
    identificationNr: '722659263',
    parentNameId: MockDBId.Customer_03,
    parentId: '24671825R',
    accountNumber: 'MMC20112511297409',
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [
      Tag.IS_TARIFF_MOBILE,
      Tag.IS_PREPAID,
      Tag.IS_ACTIVATED,
      Tag.IS_GROUP_ONFLY,
      Tag.IN_ACCOUNT_WITH_MANY_PACKAGES,
    ],
  },

  [MockDBId.Customer_03_Subscription_02_BonusesAvailable_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_02_BonusesAvailable_01,
    id: '',
    parentNameId: MockDBId.Customer_03_Subscription_02,
    parentId: '11111111',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD, Tag.HAS_0_ELE],
    ele: AllMocks.Customer_03_Subscription_02_BonusesAvailable_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/11111111/bonuses/available`,
          {
            params: { tariffId: '249', provinceId: '8' },
          },
        )
        .reply(() => [200, AllMocks.Customer_03_Subscription_02_BonusesAvailable_01])
    },
  },

  [MockDBId.Customer_03_Subscription_03]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_02,
    id: '15252908',
    identificationNr: '933215523',
    parentNameId: MockDBId.Customer_03,
    parentId: '24671825R',
    accountNumber: 'MMC1910169776468',
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [Tag.IS_TARIFF_MOBILE, Tag.IS_PREPAID, Tag.IS_ACTIVATED, Tag.IN_ACCOUNT_WITH_1_PACKAGE],
  },

  [MockDBId.Customer_03_Subscription_04]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_03_Subscription_04,
    id: '2222222',
    identificationNr: '722659264',
    parentNameId: MockDBId.Customer_03,
    parentId: '24671825R',
    accountNumber: 'MMC20112511297409',
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [
      Tag.IS_TARIFF_MOBILE,
      Tag.IS_PREPAID,
      Tag.IS_NOT_ACTIVATED,
      Tag.IS_GROUP_ONFLY,
      Tag.IN_ACCOUNT_WITH_MANY_PACKAGES,
    ],
  },

  // #################
  // ## Customer_04 ##
  // #################

  [MockDBId.Customer_04]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_04,
    id: '97569580S',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [
      Tag.SINGLE_ACCOUNT,
      Tag.HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS,
      Tag.HAS_BALANCE,
      Tag.HAS_0_ENERGY_CONTRACTS,
    ],
    ele: AllMocks.Customer_04,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onPost(`${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/customers/search`, {
          asymmetricMatch(body: any) {
            return body.document === '97569580S' && body.documentType === 'NIF'
          },
        })
        .reply(() => [200, AllMocks.Customer_04])
    },
  },

  [MockDBId.Customer_04_Subscription_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_04_Subscription_01,
    id: '18775361',
    parentNameId: MockDBId.Customer_04,
    identificationNr: '680172602',
    accountNumber: 'MMC20111611257569',
    parentId: '97569580S',
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [
      Tag.HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS,
      Tag.IS_ACTIVATED,
      Tag.HAS_BONUSES,
      Tag.HAS_PROMOTIONS,
      Tag.HAS_CONSUMPTIONS,
      Tag.HAS_BARRINGS,
      Tag.HAS_SERVICES,
    ],
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(`${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18775361`)
        .reply(() => [200, AllMocks.Customer_04_Subscription_01_SubscriptionDetail_01])
    },
  },

  [MockDBId.Customer_04_Subscription_01_SubscriptionDetail_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_04_Subscription_01_SubscriptionDetail_01,
    id: '18775361',
    parentNameId: MockDBId.Customer_04_Subscription_01,
    parentId: '18775361',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_04_Subscription_01_SubscriptionDetail_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(`${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18775361`)
        .reply(() => [200, AllMocks.Customer_04_Subscription_01_SubscriptionDetail_01])
    },
  },

  [MockDBId.Customer_04_Subscription_01_Bonuses_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_04_Subscription_01_Bonuses_01,
    id: '',
    parentNameId: MockDBId.Customer_04_Subscription_01,
    parentId: '18775361',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_04_Subscription_01_Bonuses_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18775361/bonuses`,
          {
            params: { tariffId: '362', provinceId: '30' },
          },
        )
        .reply(() => [200, AllMocks.Customer_04_Subscription_01_Bonuses_01])
    },
  },

  [MockDBId.Customer_04_Subscription_01_Promotions_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_04_Subscription_01_Promotions_01,
    id: '',
    parentNameId: MockDBId.Customer_04_Subscription_01,
    parentId: '18775361',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_04_Subscription_01_Promotions_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18775361/promotions`,
          {
            params: { tariffId: '362', provinceId: '30', accountId: '11257569', bundleType: '453' },
          },
        )
        .reply(() => [200, AllMocks.Customer_04_Subscription_01_Promotions_01])
    },
  },

  [MockDBId.Customer_04_Energy_01]: {
    mockType: 'EnergyContractInfoMock',
    nameId: MockDBId.Customer_04_Energy_01,
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onPost(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/customers/contracts/energy/search`,
          {
            asymmetricMatch(body: any) {
              return body.document === '97569580S'
            },
          },
        )
        .reply(() => [200, AllMocks.Customer_04_Energy_01])
    },
  },

  [MockDBId.Customer_04_Subscription_01_Barring_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_04_Subscription_01_Barring_01,
    id: '',
    parentNameId: MockDBId.Customer_04_Subscription_01,
    parentId: '18775361',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_04_Subscription_01_Barring_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18775361/barrings`,
        )
        .reply(() => [200, AllMocks.Customer_04_Subscription_01_Barring_01])
    },
  },

  [MockDBId.Customer_04_Subscription_01_Service_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_04_Subscription_01_Service_01,
    id: '',
    parentNameId: MockDBId.Customer_04_Subscription_01,
    parentId: '18775361',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_04_Subscription_01_Service_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/18775361/services`,
        )
        .reply(() => [200, AllMocks.Customer_04_Subscription_01_Service_01])
    },
  },

  // #################
  // ## Customer_05 ##
  // #################

  [MockDBId.Customer_05]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05,
    id: '11659304Y',
    type: MockType.SERVICE,
    brand: Brand.llamaya,
    tags: [
      Tag.SINGLE_ACCOUNT,
      Tag.HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS,
      Tag.HAS_BALANCE,
      Tag.HAS_CONSUMPTIONS,
    ],
    ele: AllMocks.Customer_05,
    addInterceptor: function addInterceptor(mockAdapter: MockAdapter) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this
      mockAdapter
        .onPost(`${commonApiGateway}/customers/v7/orgs/${this.brand}/customers/search`, {
          asymmetricMatch(body: any) {
            return body.document === '11659304Y' && body.documentType === 'NIF'
          },
        })
        .reply(function mm() {
          if (that.brand === Brand.llamaya) {
            return [200, AllMocks.Customer_05]
          }
          return [404, {}]
        })
    },
  },

  [MockDBId.Customer_05_Subscription_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01,
    id: '10197924',
    parentNameId: MockDBId.Customer_05,
    identificationNr: '666111111',
    parentId: '11659304Y',
    accountNumber: 'LLC1807208150998',
    type: MockType.MODEL,
    brand: Brand.llamaya,
    tags: [
      Tag.HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS,
      Tag.IS_ACTIVATED,
      Tag.HAS_BONUSES,
      Tag.HAS_PROMOTIONS,
      Tag.HAS_CONSUMPTIONS,
      Tag.HAS_BARRINGS,
      Tag.HAS_SERVICES,
    ],
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(`${commonApiGateway}/customers/v7/orgs/${Brand.llamaya}/subscriptions/10197924`)
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_SubscriptionDetail_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_SubscriptionDetail_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_SubscriptionDetail_01,
    id: '10197924',
    parentNameId: MockDBId.Customer_05_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.llamaya,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_SubscriptionDetail_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(`${commonApiGateway}/customers/v7/orgs/${Brand.llamaya}/subscriptions/10197924`)
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_SubscriptionDetail_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_Bonuses_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_Bonuses_01,
    id: '',
    parentNameId: MockDBId.Customer_05_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.llamaya,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_Bonuses_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.llamaya}/subscriptions/10197924/bonuses`,
          {
            params: { tariffId: '4004', provinceId: '18' },
          },
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_Bonuses_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_Promotions_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_Promotions_01,
    id: '',
    parentNameId: MockDBId.Customer_05_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.llamaya,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_Promotions_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.llamaya}/subscriptions/10197924/promotions`,
          {
            params: { tariffId: '4004', provinceId: '18', accountId: '8150998' },
          },
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_Promotions_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_Consumptions_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_Consumptions_01,
    id: '',
    parentNameId: MockDBId.Customer_05_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.llamaya,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_Consumptions_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          new RegExp(
            `^${commonApiGateway}/customers/v7/orgs/(?:masmovil|llamaya)/subscriptions/10197924/consumption$`,
          ),
          {
            params: { provinceId: '18' },
          },
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_Consumptions_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_BonusesAvailable_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_BonusesAvailable_01,
    id: '',
    parentNameId: MockDBId.Customer_03_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD, Tag.HAS_TWO_ELE],
    ele: AllMocks.Customer_05_Subscription_01_BonusesAvailable_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/10197924/bonuses/available`,
          {
            params: { tariffId: '4004', provinceId: '18' },
          },
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_BonusesAvailable_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_Recharges_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_Recharges_01,
    id: '',
    parentNameId: MockDBId.Customer_05_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_Recharges_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          new RegExp(
            `^${commonApiGateway}/customers/v7/orgs/(?:masmovil|llamaya)/subscriptions/10197924/recharges$`,
          ),
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_Recharges_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_Balance_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_Balance_01,
    id: '',
    parentNameId: MockDBId.Customer_03_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_Balance_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          new RegExp(
            `^${commonApiGateway}/customers/v7/orgs/(?:masmovil|llamaya)/subscriptions/10197924/balance$`,
          ),
          {
            params: { provinceId: '18' },
          },
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_Balance_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_Barring_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_Barring_01,
    id: '',
    parentNameId: MockDBId.Customer_05_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_Barring_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/10197924/barrings`,
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_Barring_01])
    },
  },

  [MockDBId.Customer_05_Subscription_01_Service_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_05_Subscription_01_Service_01,
    id: '',
    parentNameId: MockDBId.Customer_05_Subscription_01,
    parentId: '10197924',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.STANDARD],
    ele: AllMocks.Customer_05_Subscription_01_Service_01,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(
          `${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/subscriptions/10197924/services`,
        )
        .reply(() => [200, AllMocks.Customer_05_Subscription_01_Service_01])
    },
  },

  // #################
  // ## Customer_06 ##
  // #################

  [MockDBId.Customer_06]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_06,
    id: 'N0209256G',
    type: MockType.SERVICE,
    brand: Brand.masmovil,
    tags: [Tag.TWO_ACCOUNTS, Tag.HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS, Tag.IS_BUSINESS],
    ele: AllMocks.Customer_06,
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onPost(`${commonApiGateway}/customers/v7/orgs/${Brand.masmovil}/customers/search`, {
          asymmetricMatch(body: any) {
            return body.document === 'N0209256G' && body.documentType === 'CIF'
          },
        })
        .reply(() => [200, AllMocks.Customer_06])
    },
  },

  [MockDBId.Customer_06_Subscription_01]: {
    mockType: 'CustomerInfoMock',
    nameId: MockDBId.Customer_06_Subscription_01,
    id: '18854868',
    parentNameId: MockDBId.Customer_06,
    identificationNr: '856547959',
    parentId: 'N0209256G',
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [Tag.IS_FIBER, Tag.IS_ACTIVATED, Tag.HAS_PROMOTIONS],
  },

  // #################
  // ## Agent ##
  // #################

  [MockDBId.Agent_01]: {
    mockType: 'AgentInfoMock',
    nameId: MockDBId.Agent_01,
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [Tag.HAS_PERMISSION_CUSTOMER, Tag.HAS_PERMISSION_OFFERS_CONFIGURATOR],
    sub: 'agent_01@mock.com',
    familyName: 'Agent_01',
    givenName: 'Agent_01',
  },

  [MockDBId.Agent_02]: {
    mockType: 'AgentInfoMock',
    nameId: MockDBId.Agent_02,
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [Tag.HAS_PERMISSION_CUSTOMER, Tag.HAS_PERMISSION_PRODUCT, Tag.HAS_PERMISSION_RECHARGES],
    sub: 'agent_02@mock.com',
    familyName: 'Agent_02',
    givenName: 'Agent_02',
  },

  [MockDBId.Agent_03]: {
    mockType: 'AgentInfoMock',
    nameId: MockDBId.Agent_03,
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [Tag.HAS_PERMISSION_CUSTOMER],
    sub: 'agent_03@mock.com',
    familyName: 'Agent_03',
    givenName: 'Agent_03',
  },

  [MockDBId.Agent_04]: {
    mockType: 'AgentInfoMock',
    nameId: MockDBId.Agent_04,
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [Tag.HAS_NO_PERMISSIONS],
    sub: 'agent_04@mock.com',
    familyName: 'Agent_04',
    givenName: 'Agent_04',
  },

  [MockDBId.Agent_All]: {
    mockType: 'AgentInfoMock',
    nameId: MockDBId.Agent_All,
    type: MockType.MODEL,
    brand: Brand.masmovil,
    tags: [],
    sub: 'agent_all@mock.com',
    familyName: '',
    givenName: '',
    addInterceptor: (mockAdapter: MockAdapter) => {
      mockAdapter
        .onGet(`${commonApiGateway}/toolkit/v1/authz/permissions`)
        .reply(function mm(config) {
          if (config.headers?.['x-sfid'] === 'agent_01@mock.com') {
            return [200, AllMocks.Agent_01_Permissions_01]
          }
          if (config.headers?.['x-sfid'] === 'agent_02@mock.com') {
            return [200, AllMocks.Agent_02_Permissions_01]
          }
          if (config.headers?.['x-sfid'] === 'agent_03@mock.com') {
            return [200, AllMocks.Agent_03_Permissions_01]
          }
          if (config.headers?.['x-sfid'] === 'agent_04@mock.com') {
            return [200, AllMocks.Agent_04_Permissions_01]
          }
          return [200, AllMocks.Agent_All_Permissions_01]
        })
    },
  },
}
